import { createContext, useContext, useState } from 'react';
import { List } from 'immutable';
import { FROM_NUMBER, getPersistedFromNumberWithFallback } from 'calling-lifecycle-internal/utils/getLocalCallSettings';
import FromNumber from 'calling-internal-common/calls-v1-settings/records/InitialLoadSettingsRecords/FromNumber';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallFromNumberContext = /*#__PURE__*/createContext({
  selectedFromNumber: new FromNumber(),
  setSelectedFromNumber: () => void 0,
  hubspotProvidedNumbers: List()
});
export const CallFromNumberContextProvider = ({
  children,
  inboundCallDestinationPhoneNumber,
  settingsOmnibus
}) => {
  const [selectedFromNumber, setSelectedFromNumber] = useState(null);
  const [hubspotProvidedNumbers, setHubspotProvidedNumbers] = useState(List());

  // Set default values if settingsOmnibus or callFromNumber changes
  useEffect(() => {
    const phoneNumbers = settingsOmnibus && settingsOmnibus.get('phoneNumbers');
    const _hubspotProvidedNumbers = phoneNumbers && phoneNumbers.get('HUBSPOT_PORTAL_SUBACCOUNT') || List();
    const foundFromNumber = _hubspotProvidedNumbers.find(hubspotProvidedNumber => inboundCallDestinationPhoneNumber === hubspotProvidedNumber.get('phoneNumber'));
    const _selectedFromNumber = foundFromNumber || getPersistedFromNumberWithFallback({
      fromNumberKey: FROM_NUMBER,
      fromNumbers: _hubspotProvidedNumbers
    });
    setHubspotProvidedNumbers(_hubspotProvidedNumbers);
    setSelectedFromNumber(_selectedFromNumber);
  }, [settingsOmnibus, inboundCallDestinationPhoneNumber]);
  return /*#__PURE__*/_jsx(CallFromNumberContext.Provider, {
    value: {
      selectedFromNumber,
      setSelectedFromNumber,
      hubspotProvidedNumbers
    },
    children: children
  });
};
export const useCallFromNumberContext = () => {
  return useContext(CallFromNumberContext);
};